import { render, staticRenderFns } from "./Invitations.vue?vue&type=template&id=41749d6c"
import script from "./Invitations.vue?vue&type=script&lang=js"
export * from "./Invitations.vue?vue&type=script&lang=js"
import style0 from "./Invitations.vue?vue&type=style&index=0&id=41749d6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/Invitations.vue
// module id = null
// module chunks = 